import { TYPES } from '../../organizedByType/actions/navbarActions'
const INITIAL_STATE = {
  showHeaderShareButtons: false,
}

const REACHED_COVER_SOCIAL_COMPONENT = 'NAVBAR:ACTIONS:REACHED_COVER_SOCIAL_COMPONENT'

export function shareButtonsReducers(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REACHED_COVER_SOCIAL_COMPONENT:
      return { ...state, showHeaderShareButtons: !state.showHeaderShareButtons }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/shareButtons/shareButtons.reducers.js